import { parsePhoneNumber } from "libphonenumber-js";
import Country from "../model/address/Country";

export function formatPhoneNumberWithLink(number: string): string {
  return `<a href="tel:${number}">${formatPhoneNumber(number)}</a>`;
}

export function formatPhoneNumber(number: string): string {
  try {
    return parsePhoneNumber(number).formatNational();
  } catch (e) {
    return number;
  }
}

export function getCountryFromPhoneNumberOrDefault(
  availableCountries: Country[],
  number?: string,
  defaultCountryName?: string
) {
  return (
    (number &&
      availableCountries.find((country) => parsePhoneNumber(number).country == country.code)) ??
    availableCountries.find((country) => defaultCountryName == country.name) ??
    availableCountries[0]
  );
}
